// Module
var code = `<bds-paper class="flex flex-column bg-color-surface-0 w-100 mt-card mt3-custom" elevation="none" ng-if="!\$ctrl.onlyPreview && !\$ctrl.\$scope.editionEnabled"> <button class="flex items-center mt-card__btn mt-card__edit dn" ng-if="!\$ctrl.onlyPreview && !\$ctrl.\$scope.editionEnabled" ng-click="\$ctrl.enableEdition()"> <icon name="Edit"></icon> </button> <bds-carousel class="pt3-custom" arrows="inside" bullets="none" gap="2" slide-per-page="2" ng-if="!\$ctrl.\$scope.editionEnabled"> <bds-carousel-item ng-repeat="card in \$ctrl.cards track by \$index"> <bds-grid direction="column" align-items="center" justify-content="center" ng-click="\$ctrl.enableEdition()"> <bds-paper class="pa3-custom bg-color-surface-2 carousel-card__paper" elevation="none"> <img ng-if="\$ctrl.carouselType === 'image'" class="carousel-card__image" alt="{{'messageTemplateCarouselCard.media.text' | translate:{index: \$index + 1} }}" src="{{ card.mediaLink || \$ctrl.defaultImage[\$index] }}"/> <video ng-if="\$ctrl.carouselType === 'video'" class="carousel-card__video" ng-src="{{ card.mediaLink | trustedFilter }}" controls muted> </video> <bds-typo class="mt3" variant="fs-14"> <bds-typo class="typo-color-legend" tag="span" variant="fs-14" ng-click="\$ctrl.enableEdition()"> {{ 'messageTemplateCarouselCard.clickToEdit' | translate }} </bds-typo> </bds-typo> </bds-paper> </bds-grid> </bds-carousel-item> </bds-carousel> </bds-paper> <bds-paper class="flex flex-column bg-color-surface-0 w-100 mt-card mt3-custom" elevation="none" ng-if="\$ctrl.onlyPreview"> <bds-typo class="mb3-custom" variant="fs-14" translate> messageTemplateCarouselCard.previewTitle </bds-typo> <bds-carousel class="pt3-custom" arrows="inside" bullets="none" gap="2" slide-per-page="1"> <bds-carousel-item ng-repeat="previewCard in \$ctrl.previewCards track by \$index"> <bds-grid direction="column" align-items="center" justify-content="center"> <bds-paper class="pa3-custom bg-color-surface-2 carousel-card__paper" border elevation="none"> <img ng-if="previewCard.mediaType === 'image'" class="carousel-card__image" alt="{{'messageTemplateCarouselCard.media.textPreview' | translate}}" ng-src="{{ previewCard.mediaLink }}"/> <video ng-if="previewCard.mediaType === 'video'" class="carousel-card__video" ng-src="{{ previewCard.mediaLink | trustedFilter }}" controls muted> </video> <bds-typo class="mt3" variant="fs-14"> {{ previewCard.text }} </bds-typo> </bds-paper> </bds-grid> </bds-carousel-item> </bds-carousel> </bds-paper> <div class="mt-card w-100 relative" ng-if="\$ctrl.\$scope.editionEnabled"> <button class="mt-card__btn mt-card__close flex items-center" ng-click="\$ctrl.closeEditionConfirmation()"> <icon name="Close"></icon> </button> <button class="mt-card__btn mt-card__confirm flex items-center" ng-click="\$ctrl.save()"> <icon name="Confirm"></icon> </button> <div ng-include="'carouselCardEditTemplate'"></div> </div> ${"<" + "script"} type="text/ng-template" id="carouselCardDefaultTemplate"> <bds-paper class="pa3-custom" elevation="none">
        <bds-grid
            direction="column"
            align-items="center"
            justify-content="center"
        >
            <img
                class="carousel-card__image-template"
                src="{{ \$ctrl.card.mediaLink }}"
            />
            <bds-typo class="mt3" variant="fs-14">
                {{ \$ctrl.card.text }}
            </bds-typo>
        </bds-grid>
    </bds-paper> ${"<" + "/script"}> ${"<" + "script"} type="text/ng-template" id="carouselCardEditTemplate"> <bds-grid direction="column">
            <bds-typo class="flex ma3-custom" variant="fs-14">
                {{ 'messageTemplateCarouselCard.introText' | translate  }}
                <a href="https://help.blip.ai/hc/pt-br/articles/24288080745111-Carrossel-Templates" target="_blank">{{ 'messageTemplateCarouselCard.introTextLink' | translate }}</a>
            </bds-typo>
            <bds-select
                class="ma3-custom mt0"
                name="toneAndVoice"
                value="{{\$ctrl.carouselType}}"
                label="{{'messageTemplateCarouselCard.carouselTypeLabel' | translate}}"
                placeholder="{{'messageTemplateCarouselCard.carouselTypePlaceholder' | translate}}"
                required
                custom-events="[{ event:'bdsChange', cb: \$ctrl.handleCarouselTypeChange }]"
            >
                <bds-select-option value="image" translate>messageTemplateCarouselCard.carouselTypeImage</bds-select-option>
                <bds-select-option value="video" translate>messageTemplateCarouselCard.carouselTypeVideo</bds-select-option>
            </bds-select>

            <div class="pl3-custom pr3-custom">
                <textarea
                    class="mt-card__textarea mt-card__text"
                    rows="3"
                    placeholder="{{'messageTemplateCarouselCard.bodyTextPlaceholder' | translate}}"
                    maxlength="1024"
                    ng-model="\$ctrl.\$scope.bodyText"
                    ng-init="\$ctrl.addListenerOnTextarea()"
                ></textarea>
            </div>

            <div class="mt-card__text-formatting ml3-custom mr3-custom">
                <icon name="Bold" ng-click="\$ctrl.applyBoldOnText()"></icon>
                <icon
                    name="Italic"
                    ng-click="\$ctrl.applyItalicOnText()"
                    width="16"
                    height="16"
                ></icon>
                <icon
                    name="Strikethrough"
                    ng-click="\$ctrl.applyStrikethroughOnText()"
                    width="16"
                    height="16"
                ></icon>

                <span
                    class="mt-card__text-formatting__add-variable"
                    ng-click="\$ctrl.addVariable()"
                >
                    <icon name="Add"></icon>
                    {{ 'messageTemplateCarouselCard.variable' | translate }}
                </span>
            </div>
        </bds-grid>

        <bds-grid direction="column" align-items="flex-end">
            
        </bds-grid>

        <bds-loading-spinner
            color="light"
            size="small"
            ng-show="\$ctrl.isLoading"
            style="width: 100%; height: 70vh;"
        ></bds-loading-spinner>

        <bds-tab-group ng-if="!\$ctrl.isLoading" class="pt5" content-scrollable align="left">
            <bds-tab-item
                label="{{'messageTemplateCarouselCard.cardTitle' | translate}} {{\$index + 1}}"
                ng-repeat="card in \$ctrl.cards track by \$index"
            >
                <bds-button
                    class="absolute right-0 carousel-card__add-button"
                    variant="text"
                    icon-left="add"
                    color="content"
                    ng-disabled="\$ctrl.cards.length >= 10"
                    ng-click="\$ctrl.addCard(\$index)"
                    translate>
                    messageTemplateCarouselCard.addCard
                </bds-button>

                <bds-paper
                    class="pa3-custom ma3-custom bg-color-surface-1 carousel-card__border"
                    elevation="none"
                >
                    <bds-grid
                        justify-content="space-between"
                        align-items="center"
                    >
                        <bds-typo
                            class="flex mb3-custom mt3-custom"
                            variant="fs-16"
                            bold="bold"
                        >
                            {{'messageTemplateCarouselCard.cardTitle' | translate}} {{\$index + 1}}
                        </bds-typo>
                        <div>
                            <bds-button
                                group-icon
                                color="content"
                                icon-left="trash"
                                icon-theme="outline"
                                justify-content="center"
                                size="medium"
                                type="button"
                                type-icon="icon"
                                variant="text"
                                ng-click="\$ctrl.removeCard(\$index)"
                                ng-disabled="\$ctrl.cards.length <= 2"
                            ></bds-button>
                        </div>
                    </bds-grid>

                    <bds-input
                        class="mb4"
                        name="media-link-{{\$index}}"
                        type="text"
                        value="{{card.mediaLink}}"
                        label="{{'messageTemplateCarouselCard.media.linkLabel' | translate}}"
                        placeholder="{{\$ctrl.carouselType === 'image' ? ('messageTemplateCarouselCard.media.linkPlaceholderImage' | translate) : ('messageTemplateCarouselCard.media.linkPlaceholderVideo' | translate)}}"
                        required
                        custom-events="[{ event: 'bdsChange', cb: \$ctrl.handleMediaLinkChange }]"
                    ></bds-input>

                   <textarea
                        class="mt-card__textarea mt-card__text"
                        name="card-title-{{\$index}}"
                        rows="3"
                        placeholder="{{'messageTemplateCarouselCard.textPlaceholder' | translate}}"
                        maxlength="1024"
                        ng-model="card.text"
                    >
                    </textarea>

                    <div class="mt-card__text-formatting mb3">
                        <span
                            class="mt-card__text-formatting__add-variable"
                            ng-click="\$ctrl.addVariableToCardText(\$index)"
                        >
                            <icon name="Add"></icon>
                            {{ 'messageTemplateCarouselCard.variable' | translate }}
                        </span>
                    </div>
                </bds-paper>

                <bds-grid class="mb4" direction="column" align-items="flex-end">
                    <bds-button
                        variant="text"
                        icon-left="add"
                        color="content"
                        ng-click="\$ctrl.addButton(\$index)"
                        ng-disabled="card.buttons && card.buttons.length >= 3"
                        translate>
                        messageTemplateCarouselCard.addButton
                    </bds-button>
                </bds-grid>

                <div ng-repeat="button in card.buttons track by \$index">
                    <bds-paper
                        class="ma3-custom pa3-custom bg-color-surface-1 carousel-card__border"
                        elevation="none"
                    >
                        <bds-grid
                            justify-content="space-between"
                            align-items="center"
                        >
                            <bds-typo class="flex mb4" variant="fs-16" bold="bold">
                                {{'messageTemplateCarouselCard.button.title' | translate}} {{\$index + 1}}
                            </bds-typo>
                            <div>
                                <bds-button
                                    group-icon
                                    color="content"
                                    icon-left="trash"
                                    icon-theme="outline"
                                    justify-content="center"
                                    size="medium"
                                    type="button"
                                    type-icon="icon"
                                    variant="text"
                                    ng-click="\$ctrl.removeButton(\$parent.\$index, \$index)"
                                    ng-disabled="card.buttons.length <= 1"
                                ></bds-button>
                            </div>
                        </bds-grid>

                        <bds-select
                            class="mb3"
                            name="buttonType-{{\$parent.\$index}}-{{\$index}}"
                            value="{{button.type}}"
                            label="{{'messageTemplateCarouselCard.button.typeLabel' | translate}}"
                            placeholder="{{'messageTemplateCarouselCard.button.typePlaceholder' | translate}}"
                            required
                            danger="{{!button.type}}"
                            custom-events="[{ event:'bdsChange', cb: \$ctrl.handleButtonTypeChange}]"
                        >
                            <bds-select-option ng-repeat="option in \$ctrl.getButtonOptions(\$index)" value="{{ option.value }}"  title-text="{{ option.label | translate }}">
                            </bds-select-option>
                        </bds-select>

                        <bds-input
                            class="mb3"
                            name="text-{{\$index}}-{{\$parent.\$index}}"
                            type="text"
                            value="{{button.text}}"
                            label="{{'messageTemplateCarouselCard.button.textLabel' | translate}}"
                            placeholder="{{'messageTemplateCarouselCard.button.textPlaceholder' | translate}}"
                            maxlength="20"
                            required
                            custom-events="[{ event: 'bdsChange', cb: \$ctrl.handleButtonFieldChange }]"
                        ></bds-input>

                        <bds-input
                            class="mb3"
                            name="url-{{\$index}}-{{\$parent.\$index}}"
                            type="text"
                            value="{{button.url}}"
                            label="{{'messageTemplateCarouselCard.button.urlLabel' | translate}}"
                            placeholder="{{'messageTemplateCarouselCard.button.urlPlaceholder' | translate}}"
                            helper-message="{{'messageTemplateCarouselCard.button.urlHelper' | translate}}"
                            required
                            ng-show="button.type === 'url'"
                            custom-events="[{ event: 'bdsChange', cb: \$ctrl.handleButtonFieldChange }]"
                        ></bds-input>

                        <bds-input
                            class="mb3"
                            name="phone_number-{{\$index}}-{{\$parent.\$index}}"
                            type="text"
                            value="{{button.phone_number}}"
                            label="{{'messageTemplateCarouselCard.button.phoneLabel' | translate}}"
                            placeholder="{{'messageTemplateCarouselCard.button.phonePlaceholder' | translate}}"
                            maxlength="20"
                            helper-message="{{'messageTemplateCarouselCard.button.phoneHelper' | translate}}"
                            required
                            ng-show="button.type === 'phone_number'"
                            custom-events="[{ event: 'bdsChange', cb: \$ctrl.handleButtonFieldChange }]"
                        ></bds-input>
                    </bds-paper>
                </div>
            </bds-tab-item>
        </bds-tab-group> ${"<" + "/script"}> `;
// Exports
module.exports = code;